import uniqueId from "lodash.uniqueid";
import React, { useRef } from "react";
import {
  showSSRHydrationWarning,
  isPropEmpty,
} from "../utils/SSR/showSSRHydrationWarning";
import { useSSR } from "../utils/SSR/useSSR";
import { TableEditableFieldProps } from "./table.types";

export const TableEditableField = ({
  value,
  onChange = (): void => {},
  "aria-label": ariaLabel,
  "aria-invalid": ariaInvalid,
  statusMessage,
  statusMessageId,
  name,
  ...rest
}: TableEditableFieldProps): React.ReactElement => {
  const idRef = useRef(uniqueId("table-cell-status-"));

  useSSR(() => {
    if (statusMessage) {
      isPropEmpty(statusMessageId) &&
        showSSRHydrationWarning("statusMessageId", "TableEditableField");
    }
  });

  if (!statusMessage) {
    return (
      <input
        type="text"
        value={value}
        name={name}
        aria-label={ariaLabel}
        onChange={(e): void => onChange(e, e.target.value)}
        {...rest}
      />
    );
  }

  const messageId = statusMessageId || idRef.current;
  return (
    <span className="spark-table__status-wrapper">
      <span className="spark-table__status-icon"></span>
      <input
        type="text"
        value={value}
        name={name}
        aria-invalid={ariaInvalid}
        aria-label={ariaLabel}
        aria-describedby={messageId}
        onChange={(e): void => onChange(e, e.target.value)}
        {...rest}
      />
      <span className="spark-table__status-message" id={messageId}>
        {statusMessage}
      </span>
    </span>
  );
};

TableEditableField.displayName = "TableEditableField";
